import Keycloak from 'keycloak-js';

// Cada endereço do sistema tem seu client no Keycloak (e com ele a tela de login da marca)
const CLIENTS_POR_ENDERECO: Record<string, string> = {
    'app.monluc.com.br': 'monluc-web',
    'monluc.local.localnet': 'monluc-web',
};

// Login no Keycloak (realm "vigento"). Fora de produção, aponte para outro servidor com REACT_APP_KEYCLOAK_URL.
export const keycloak = new Keycloak({
    url: process.env.REACT_APP_KEYCLOAK_URL || 'https://auth.vigento.com.br',
    realm: process.env.REACT_APP_KEYCLOAK_REALM || 'vigento',
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || CLIENTS_POR_ENDERECO[window.location.hostname] || 'vigento-web',
});
